import React from 'react';

const Header = () => (
    <header>
        <h1 className="title">Tourn</h1>
    </header>
);

export default Header;